import { render, staticRenderFns } from "./freelancer_apply_xhs_entry.vue?vue&type=template&id=768e2af8&scoped=true&"
import script from "./freelancer_apply_xhs_entry.vue?vue&type=script&lang=js&"
export * from "./freelancer_apply_xhs_entry.vue?vue&type=script&lang=js&"
import style0 from "./freelancer_apply_xhs_entry.vue?vue&type=style&index=0&id=768e2af8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768e2af8",
  null
  
)

export default component.exports